import Cookies from 'universal-cookie';
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

export const FlyLandingRedirect = () => {
  const cookies = new Cookies();
  cookies.set('last_landing_rule', '/fly', { domain: cookieDomain });
  cookies.set('landing_page', '/fly', { domain: cookieDomain });
  window.location = '/';
  return null;
};
